import Paginator from '@/models/Paginator'
import { assetTransfer as backend } from '@/api'

let assetTransfer = {

  namespaced: true,

  state: {
    transfers: new Paginator,
  },

  mutations: {
    setTransfers: (state, payload) => state.transfers = payload,
    clear: (state) => state.transfers = new Paginator,
  },

  actions: {
    loadReport: ({ commit }, payload) => new Promise((resolve, reject) => {
      backend.loadReport(payload, ({ data }) => {
        commit('setTransfers', data)
        resolve()
      }, error => reject(error))
    }),
  },

  getters: {
    transfers: state => state.transfers,
  }

}

export default assetTransfer
